import React, { useEffect, useState } from "react";
import { Button, DatePicker, Input, Select, Switch } from "antd";
import { ErrorToast, SuccessToast } from "../../../../widgets/AppToast";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import useUserData from "../../../../hooks/useUserData";
import moment from "moment";
import UnitWithInput from "../../../../components/UnitWithInput";
import { currentUnits, loadUnits, pressureUnits } from "../../../../Data/data";
import dayjs from "dayjs";
import { useDate } from "../../../../context/DateContext";

function AuxiliaryBoiler({ eng_log_basic_id, _items }) {
  const user = useUserData(); 
  const { selectedDate } = useDate();
  const [loader, set_loader] = useState(false);
  const [errors, set_errors] = useState({});
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [boiler_Pr, set_Boiler_Pr] = useState("");
  const [fuel_Pr, set_Fuel_Pr] = useState("");
  const [nozzle_Pr, set_Nozzle_Pr] = useState("");
  const [atomising_Pr, set_Atomising_Pr] = useState("");
  const [fd_fun_current, set_Fd_Fun_current] = useState("");
  const [boiler_Load, set_Boiler_Load] = useState("");
  const [checked, setChecked] = useState(false);
  const [running_Hour, set_Running_Hour] = useState("");
  const [total_Running_Hour, set_Total_Running_Hour] = useState("");
  const [update_status, set_update_status] = useState(false);
  const [fuel_Oil_Type, set_Fuel_Oil_Type] = useState("");
  const [other_fuel_oil_type, set_Other_fuel_oil_type] = useState("");
  const [submitStatus, setSubmitStatus] = useState(false);
  const [logDate, set_LogDate] = useState(null);
  const [boiler_Pressure_Unit, set_Boiler_Pressure_Unit] = useState("");
  const [boiler_Fuel_Pressure_Unit, set_Boiler_Fuel_Pressure_Unit] =
    useState("");
  const [boiler_Nozzle_Pressure_Unit, set_Boiler_Nozzle_Pressure_Unit] =
    useState("");
  const [boiler_Atomising_Pressure_Unit, set_Boiler_Atomising_Pressure_Unit] =
    useState("");
  const [boiler_Fd_Pressure_Unit, set_Boiler_Fd_Pressure_Unit] = useState("");
  const [boiler_Load_Pressure_Unit, set_Boiler_Load_Pressure_Unit] =
    useState("");
  const [otherParams, setOtherParams] = useState({});

  // Map parameter names to labels and units (including fuelOilType dynamically)
  const parameterConfig = {
    runningHours: { label: "Running Hour", unitList: [] },
    totalRunningHours: { label: "Total Running Hour", unitList: [] },
    boilerPressure: { label: "Boiler Pressure", unitList: pressureUnits },
    fuelPressure: { label: "Fuel Pressure", unitList: pressureUnits },
    fdFanCurrent: { label: "Forced Draft Fan Current", unitList: currentUnits },
    boilerLoad: { label: "Boiler Load", unitList: loadUnits },
    fuelOilType: {
      label: "Fuel Oil Type",
      type: "select",
      options: ["VLSFO", "LSMGO", "HSFO", "Other"],
    },
  };

  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staff_dashboards);
    set_staff_dashboard(parsedData);
    if (parsedData && _items) {
      if (_items?.id)
        VIEW_AUXILARY_BOILER_DETAILS_LOGBOOK_API(_items?.id, parsedData);
      const otherParamsData = Array.isArray(_items?.other_parameters)
        ? _items.other_parameters
        : [];
      const initialOtherParams = otherParamsData.reduce((acc, param) => {
        acc[param.name] = { value: "", unit: param.unit || "" };
        return acc;
      }, {});
      setOtherParams(initialOtherParams);
    }
  }, [_items?.id]);

  const onChangeDateTime = (value) => {
    if (value) {
      set_LogDate(value.format("YYYY-MM-DD HH:mm:ss"));
    } else {
      set_LogDate(null);
    }
  };

  const handleOtherParamChange = (name, field, value) => {
    setOtherParams((prev) => ({
      ...prev,
      [name]: { ...prev[name], [field]: value },
    }));
  };

  const ADD_AUXILARY_BOILER_DETAILS_LOGBOOK_API = async (
    boiler_id,
    boiler_on
  ) => {
    set_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append(
        "date_time_log",
        logDate || moment().format("YYYY-MM-DD HH:mm:ss")
      );
      FORM_DATA.append("eng_log_basic_id", Number(eng_log_basic_id) || 0);
      FORM_DATA.append(
        "voyage_id",
        Number(staff_dashboard?.voyage_details?.[0]?.id) || 0
      );
      FORM_DATA.append("boiler_pressure", Number(boiler_Pr) || 0);
      FORM_DATA.append("fuel_pressure", Number(fuel_Pr) || 0);
      FORM_DATA.append("boiler_load", Number(boiler_Load) || 0);
      FORM_DATA.append("boiler_id", Number(boiler_id) || 0);
      FORM_DATA.append("boiler_on_off", boiler_on);
      FORM_DATA.append("boiler_running_hours", Number(running_Hour) || 0);
      FORM_DATA.append(
        "boiler_total_running_hours",
        Number(total_Running_Hour) || 0
      );
      FORM_DATA.append("fuel_Oil_Type", fuel_Oil_Type || "");
      FORM_DATA.append("other_fuel_oil_type", other_fuel_oil_type || "");
      FORM_DATA.append("boiler_pressure_unit", boiler_Pressure_Unit || "");
      FORM_DATA.append("fuel_pressure_unit", boiler_Fuel_Pressure_Unit || "");
      FORM_DATA.append("other_parameters", JSON.stringify(otherParams));
      FORM_DATA.append("forced_draft_fan_current", Number(fd_fun_current) || 0);
      FORM_DATA.append(
        "forced_draft_fan_current_unit",
        boiler_Fd_Pressure_Unit || ""
      );
      FORM_DATA.append("boiler_load_unit", boiler_Load_Pressure_Unit || "");

      post(ApiURL.add_auxiliary_boiler_info_st, FORM_DATA).then((res) => {
        if (res?.status === true) {
          SuccessToast("Logbook Add Success!", res?.message);
          set_loader(false);
          if (staff_dashboard)
            VIEW_AUXILARY_BOILER_DETAILS_LOGBOOK_API(
              res?.boiler_data?.boiler_id,
              staff_dashboard
            );
        } else {
          ErrorToast("ERROR Message!", res?.message);
          set_errors(res?.errors || {});
        }
      });
    } catch (error) {
      console.error("Error Adding logbook:", error);
    } finally {
      set_loader(false);
    }
  };

  const UPDATE_AUXILARY_BOILER_DETAILS_LOGBOOK_API = async (
    boiler_id,
    save_submit,
    boiler_on
  ) => {
    set_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append(
        "date_time_log",
        logDate || moment().format("YYYY-MM-DD HH:mm:ss")
      );
      FORM_DATA.append("save_submit", Number(save_submit) || 0);
      FORM_DATA.append("eng_log_basic_id", Number(eng_log_basic_id) || 0);
      FORM_DATA.append(
        "voyage_id",
        Number(staff_dashboard?.voyage_details?.[0]?.id) || 0
      );
      FORM_DATA.append("boiler_pressure", Number(boiler_Pr) || 0);
      FORM_DATA.append("fuel_pressure", Number(fuel_Pr) || 0);
      FORM_DATA.append("boiler_load", Number(boiler_Load) || 0);
      FORM_DATA.append("boiler_id", Number(boiler_id) || 0);
      FORM_DATA.append("boiler_on_off", boiler_on);
      FORM_DATA.append("boiler_running_hours", Number(running_Hour) || 0);
      FORM_DATA.append(
        "boiler_total_running_hours",
        Number(total_Running_Hour) || 0
      );
      FORM_DATA.append("fuel_Oil_Type", fuel_Oil_Type || "");
      FORM_DATA.append("other_fuel_oil_type", other_fuel_oil_type || "");
      FORM_DATA.append("boiler_pressure_unit", boiler_Pressure_Unit || "");
      FORM_DATA.append("fuel_pressure_unit", boiler_Fuel_Pressure_Unit || "");
      FORM_DATA.append("other_parameters", JSON.stringify(otherParams));
      FORM_DATA.append("forced_draft_fan_current", Number(fd_fun_current) || 0);
      FORM_DATA.append(
        "forced_draft_fan_current_unit",
        boiler_Fd_Pressure_Unit || ""
      );
      FORM_DATA.append("boiler_load_unit", boiler_Load_Pressure_Unit || "");

      post(ApiURL.view_update_auxiliary_boiler_st, FORM_DATA).then((res) => {
        if (res?.status === true) {
          SuccessToast("Logbook Update Success!", res?.message);
          set_loader(false);
          if (staff_dashboard)
            VIEW_AUXILARY_BOILER_DETAILS_LOGBOOK_API(
              res?.boiler_data?.boiler_id,
              staff_dashboard
            );
        } else {
          ErrorToast("Error message", "Submission failed! Please try again.");
          set_errors(res?.errors || {});
        }
      });
    } catch (error) {
      console.error("Error Updating logbook:", error);
    } finally {
      set_loader(false);
    }
  };

  const VIEW_AUXILARY_BOILER_DETAILS_LOGBOOK_API = async (
    boiler_id,
    voyage_id
  ) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("boiler_id", boiler_id);
      FORM_DATA.append("eng_log_basic_id", eng_log_basic_id);
      FORM_DATA.append("voyage_id", voyage_id?.voyage_details?.[0]?.id);
      post(ApiURL.view_update_auxiliary_boiler_st, FORM_DATA).then((res) => {
        const boiler_Data = res?.boiler_data;
        if (res?.status === true) {
          set_update_status(boiler_Data?.complete_status);
          set_Boiler_Pr(String(boiler_Data?.boiler_pressure) || "");
          set_Fuel_Pr(String(boiler_Data?.fuel_pressure) || "");
          set_Nozzle_Pr(String(boiler_Data?.nozzle_pressure) || "");
          set_Atomising_Pr(String(boiler_Data?.atomising_pressure) || "");
          set_Fd_Fun_current(
            String(boiler_Data?.forced_draft_fan_current) || ""
          );
          set_Boiler_Load(String(boiler_Data?.boiler_load) || "");
          setChecked(boiler_Data?.boiler_on_off || false);
          set_Running_Hour(String(boiler_Data?.boiler_running_hours) || "");
          set_Total_Running_Hour(
            String(boiler_Data?.boiler_total_running_hours) || ""
          );
          set_Fuel_Oil_Type(String(boiler_Data?.fuel_Oil_Type) || "");
          set_Other_fuel_oil_type(
            String(boiler_Data?.other_fuel_oil_type) || ""
          );
          setSubmitStatus(res?.submit_status || false);
          set_LogDate(
            String(
              boiler_Data?.date_time_log ||
                moment().format("YYYY-MM-DD HH:mm:ss")
            )
          );
          set_Boiler_Pressure_Unit(
            String(boiler_Data?.boiler_pressure_unit) || ""
          );
          set_Boiler_Fuel_Pressure_Unit(
            String(boiler_Data?.fuel_pressure_unit) || ""
          );
          set_Boiler_Nozzle_Pressure_Unit(
            String(boiler_Data?.nozzle_pressure_unit) || ""
          );
          set_Boiler_Atomising_Pressure_Unit(
            String(boiler_Data?.atomising_pressure_unit) || ""
          );
          set_Boiler_Fd_Pressure_Unit(
            String(boiler_Data?.forced_draft_fan_current_unit) || ""
          );
          set_Boiler_Load_Pressure_Unit(
            String(boiler_Data?.boiler_load_unit) || ""
          );
          // const itemParams = _items?.other_parameters || [];
          const rawItemParams = _items?.other_parameters;
          const itemParams = Array.isArray(rawItemParams) ? rawItemParams : [];
          const boilerParams = boiler_Data?.other_parameters || {};

          // Merge the two datasets
          const mergedParams = itemParams?.map((param) => {
            const paramName = param.name;
            const boilerEntry = boilerParams[paramName] || {};
            return {
              name: paramName,
              unit: param.unit || boilerEntry.unit || "",
              value: boilerEntry.value || "",
            };
          });

          const otherParamsData = Array.isArray(mergedParams)
            ? mergedParams
            : [];
          const initialOtherParams = otherParamsData.reduce((acc, param) => {
            acc[param.name] = {
              value: param.value || "",
              unit: param.unit || "",
            };
            return acc;
          }, {});

          setOtherParams(initialOtherParams);
        } else {
          set_errors(res?.errors || {});
        }
      });
    } catch (error) {
      console.error("Error updating logbook:", error);
    }
  };

  const otherParameterUnits = [
    ...new Set(Object.values(otherParams || {}).map((param) => param.unit)),
  ];

  return (
    <>
      <div className="row custom-box">
        <div className="col-3">
          <b style={{ color: "#161515", fontSize: "14px" }}>
            Boiler Make:- {_items?.boiler_make}
          </b>
        </div>
        <div className="col-3">
          <b style={{ color: "#161515", fontSize: "14px" }}>
            Boiler Model:- {_items?.boiler_model}
          </b>
        </div>
        <div className="col-3">
          <b style={{ color: "#161515", fontSize: "14px" }}>
            Boiler title:- {_items?.title}
          </b>
        </div>
        <div className="col-3">
          <b style={{ color: "#161515", fontSize: "14px" }}>
            Boiler Id:- {_items?.id}
          </b>
        </div>
        <div className="col-3">
          <b style={{ color: "#161515", fontSize: "14px" }}>
            Boiler Capacity:- {_items?.boiler_capacity}
          </b>
        </div>
        <div className="col-2">
          <Switch
            disabled={submitStatus}
            checked={checked}
            onChange={(value) => {
              setChecked(value);
              if (value || !value) {
                update_status
                  ? UPDATE_AUXILARY_BOILER_DETAILS_LOGBOOK_API(
                      _items?.id,

                      "0",
                      value
                    )
                  : ADD_AUXILARY_BOILER_DETAILS_LOGBOOK_API(_items?.id, value);
              }
            }}
            checkedChildren="On"
            unCheckedChildren="Off"
            style={{ backgroundColor: checked ? "green" : "red" }}
          />
        </div>
      </div>

      {checked && (
        <>
          {(() => {
            const rows = [];

            // Prepare the list of inputs: Start with Date & Time
            const inputs = [
              {
                type: "dateTime",
                name: "dateTime",
                value: update_status && logDate ? logDate : selectedDate,
                // value: logDate,
              },
            ];

            // Add all selected parameters
            const selectedParams = _items.selected_parameters || [];
            selectedParams.forEach((param) => {
              const config = parameterConfig[param];
              if (config) {
                const stateMap = {
                  runningHours: [running_Hour, set_Running_Hour],
                  totalRunningHours: [
                    total_Running_Hour,
                    set_Total_Running_Hour,
                  ],
                  boilerPressure: [boiler_Pr, set_Boiler_Pr],
                  fuelPressure: [fuel_Pr, set_Fuel_Pr],
                  nozzlePressure: [nozzle_Pr, set_Nozzle_Pr],
                  atomisingPressure: [atomising_Pr, set_Atomising_Pr],
                  fdFanCurrent: [fd_fun_current, set_Fd_Fun_current],
                  boilerLoad: [boiler_Load, set_Boiler_Load],
                  fuelOilType: [fuel_Oil_Type, set_Fuel_Oil_Type],
                };
                const [value] = stateMap[param] || [];
                const unitStateMap = {
                  boilerPressure: [
                    boiler_Pressure_Unit,
                    set_Boiler_Pressure_Unit,
                  ],
                  fuelPressure: [
                    boiler_Fuel_Pressure_Unit,
                    set_Boiler_Fuel_Pressure_Unit,
                  ],
                  nozzlePressure: [
                    boiler_Nozzle_Pressure_Unit,
                    set_Boiler_Nozzle_Pressure_Unit,
                  ],
                  atomisingPressure: [
                    boiler_Atomising_Pressure_Unit,
                    set_Boiler_Atomising_Pressure_Unit,
                  ],
                  fdFanCurrent: [
                    boiler_Fd_Pressure_Unit,
                    set_Boiler_Fd_Pressure_Unit,
                  ],
                  boilerLoad: [
                    boiler_Load_Pressure_Unit,
                    set_Boiler_Load_Pressure_Unit,
                  ],
                };
                const [unit] = unitStateMap[param] || [];
                inputs.push({
                  type: "selectedParam",
                  name: param,
                  config,
                  value,
                  unit,
                });
              }
            });

            // If fuel_Oil_Type is "Other", add otherFuelOilType as an input
            if (fuel_Oil_Type === "Other") {
              inputs.push({
                type: "otherFuelOilType",
                name: "otherFuelOilType",
                value: other_fuel_oil_type,
              });
            }

            // Render inputs in groups of 3
            for (let i = 0; i < inputs.length; i += 3) {
              const group = inputs.slice(i, i + 3);
              rows.push(
                <div className="row" key={`combined-row-${i}`}>
                  {group.map((input, idx) => (
                    <div
                      className="col-4"
                      key={`${input.type}-${input.name}-${idx}`}
                    >
                      {input.type === "dateTime" ? (
                        <div className="input-box">
                          <label>Date & Time</label>
                          <DatePicker
                            disabled
                            showTime
                            format="YYYY-MM-DD HH:mm:ss"
                            placeholder="Select Date & Time"
                            value={
                              input.value
                                ? dayjs(input.value, "YYYY-MM-DD HH:mm:ss")
                                : null
                            }
                            // value={
                            //   update_status && input.value
                            //     ? dayjs(input.value, "YYYY-MM-DD HH:mm:ss")
                            //     : selectedDate
                            //     ? dayjs(selectedDate, "YYYY-MM-DD HH:mm:ss")
                            //     : null
                            // }
                            onChange={onChangeDateTime}
                            style={{ width: "100%" }}
                            // disabled={submitStatus}
                          />
                          {errors.date_time_log && (
                            <p className="error-text">{errors.date_time_log}</p>
                          )}
                        </div>
                      ) : input.type === "selectedParam" ? (
                        (() => {
                          const config = input.config;
                          const stateMap = {
                            runningHours: [running_Hour, set_Running_Hour],
                            totalRunningHours: [
                              total_Running_Hour,
                              set_Total_Running_Hour,
                            ],
                            boilerPressure: [boiler_Pr, set_Boiler_Pr],
                            fuelPressure: [fuel_Pr, set_Fuel_Pr],
                            nozzlePressure: [nozzle_Pr, set_Nozzle_Pr],
                            atomisingPressure: [atomising_Pr, set_Atomising_Pr],
                            fdFanCurrent: [fd_fun_current, set_Fd_Fun_current],
                            boilerLoad: [boiler_Load, set_Boiler_Load],
                            fuelOilType: [fuel_Oil_Type, set_Fuel_Oil_Type],
                          };
                          const [, setValue] = stateMap[input.name] || [];
                          const unitStateMap = {
                            boilerPressure: [
                              boiler_Pressure_Unit,
                              set_Boiler_Pressure_Unit,
                            ],
                            fuelPressure: [
                              boiler_Fuel_Pressure_Unit,
                              set_Boiler_Fuel_Pressure_Unit,
                            ],
                            nozzlePressure: [
                              boiler_Nozzle_Pressure_Unit,
                              set_Boiler_Nozzle_Pressure_Unit,
                            ],
                            atomisingPressure: [
                              boiler_Atomising_Pressure_Unit,
                              set_Boiler_Atomising_Pressure_Unit,
                            ],
                            fdFanCurrent: [
                              boiler_Fd_Pressure_Unit,
                              set_Boiler_Fd_Pressure_Unit,
                            ],
                            boilerLoad: [
                              boiler_Load_Pressure_Unit,
                              set_Boiler_Load_Pressure_Unit,
                            ],
                          };
                          const [, setUnit] = unitStateMap[input.name] || [];
                          const errorKey = `boiler_${input.name.replace(
                            /([A-Z])/g,
                            (match) => `_${match.toLowerCase()}`
                          )}`;

                          return config.type === "select" ? (
                            <div className="input-box">
                              <label>{config.label}</label>
                              <Select
                                disabled={submitStatus}
                                value={input.value}
                                placeholder={` -- Select ${config.label} -- `}
                                style={{ width: "100%" }}
                                onChange={(val) => setValue(val)}
                              >
                                {config.options.map((option) => (
                                  <Select.Option key={option} value={option}>
                                    {option}
                                  </Select.Option>
                                ))}
                              </Select>
                              {errors?.[errorKey] && (
                                <span style={{ color: "red" }}>
                                  {errors?.[errorKey]}
                                </span>
                              )}
                            </div>
                          ) : config.unitList && config.unitList.length ? (
                            <UnitWithInput
                              label={config.label}
                              value={input.value}
                              onChange={(e) => setValue(e.target.value)}
                              unit={input.unit}
                              onUnitChange={(e) => setUnit(e.target.value)}
                              disabled={submitStatus}
                              error={errors[errorKey]}
                              unitList={config.unitList}
                            />
                          ) : (
                            <div className="input-box">
                              <label>{config.label}</label>
                              <Input
                                disabled={submitStatus}
                                value={input.value}
                                placeholder={config.label}
                                onChange={(e) => setValue(e.target.value)}
                              />
                              {errors?.[errorKey] && (
                                <span style={{ color: "red" }}>
                                  {errors[errorKey]}
                                </span>
                              )}
                            </div>
                          );
                        })()
                      ) : (
                        <div className="input-box">
                          <label>Other Fuel Oil Type</label>
                          <Input
                            disabled={submitStatus}
                            value={input.value}
                            placeholder="Other Fuel Oil Type"
                            onChange={(e) =>
                              set_Other_fuel_oil_type(e.target.value)
                            }
                          />
                          {errors?.other_fuel_oil_type && (
                            <span style={{ color: "red" }}>
                              {errors?.other_fuel_oil_type}
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                  ))}
                  {group.length < 3 &&
                    Array.from({ length: 3 - group.length }).map((_, idx) => (
                      <div
                        className="col-4"
                        key={`empty-combined-${i}-${idx}`}
                      ></div>
                    ))}
                </div>
              );
            }

            return rows;
          })()}

          {(() => {
            const rows = [];
            const otherParamsArray = Object.entries(otherParams || {});
            for (let i = 0; i < otherParamsArray.length; i += 3) {
              const group = otherParamsArray.slice(i, i + 3);
              rows.push(
                <div className="row" key={`other-row-${i}`}>
                  {group.map(([name, { value, unit }]) => (
                    <div className="col-4" key={name}>
                      <UnitWithInput
                        label={name}
                        value={value}
                        onChange={(e) =>
                          handleOtherParamChange(name, "value", e.target.value)
                        }
                        unit={unit}
                        onUnitChange={(e) =>
                          handleOtherParamChange(name, "unit", e.target.value)
                        }
                        disabled={submitStatus}
                        unitList={otherParameterUnits}
                      />
                    </div>
                  ))}
                  {group.length < 3 &&
                    Array.from({ length: 3 - group.length }).map((_, idx) => (
                      <div
                        className="col-4"
                        key={`empty-other-${i}-${idx}`}
                      ></div>
                    ))}
                </div>
              );
            }
            return rows;
          })()}

          <div
            className="row"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "15px",
              marginLeft: "5px",
            }}
          >
            {["Chief Engineer"].includes(user?.data?.designation) &&
              eng_log_basic_id && (
                <Button
                  disabled={submitStatus}
                  loading={loader}
                  className="save_btn"
                  style={{ color: "white" }}
                  onClick={() =>
                    update_status
                      ? UPDATE_AUXILARY_BOILER_DETAILS_LOGBOOK_API(
                          _items?.id,

                          "1",
                          checked
                        )
                      : ADD_AUXILARY_BOILER_DETAILS_LOGBOOK_API(
                          _items?.id,
                          checked
                        )
                  }
                >
                  Submit
                </Button>
              )}
            <Button
              disabled={submitStatus}
              loading={loader}
              className="save_btn"
              style={{ color: "white" }}
              onClick={() =>
                update_status
                  ? UPDATE_AUXILARY_BOILER_DETAILS_LOGBOOK_API(
                      _items?.id,

                      "0",
                      checked
                    )
                  : ADD_AUXILARY_BOILER_DETAILS_LOGBOOK_API(_items?.id, checked)
              }
            >
              Save
            </Button>
          </div>
        </>
      )}
    </>
  );
}

export default AuxiliaryBoiler;
